import { useEffect } from 'react';
import { useHistory } from './TypedRoute';

/**
 * Permette il funzionamento degli anchor con smooth scroll con i componenti <Link />
 */
export function useSmoothAnchorScroll() {
  const history = useHistory();

  useEffect(() => {
    const hash = history.location.hash; // Check if there is a hash and if an element with that id exists
    const el = hash && document.getElementById(hash.substring(1));
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [history.location.hash]);
}
